<template>
    <div :class="embedded ? 'nch--wiki-list nch--wiki-list__embedded' : 'container py-4 nch--wiki-list'">
        <div v-if="!embedded" class="mb-3">
            <h1 class="h3 mb-0">{{ $t('wiki.my_wikis') }}</h1>
            <div class="text-muted small">{{ $t('wiki.subtitle') }}</div>
        </div>
        <div v-if="loading" class="text-center text-muted py-5"><i class="fas fa-circle-notch fa-spin fa-2x"></i></div>
        <div v-else-if="!wikis.length" class="card shadow-sm"><div class="card-body text-center text-muted py-5">{{ $t('wiki.empty') }}</div></div>
        <a
            v-for="w in wikis"
            v-else
            :key="w.id"
            :href="`/app/wikis/${w.id}`"
            class="card shadow-sm mb-3 nch--wiki-card text-reset text-decoration-none"
        >
            <div class="card-body d-flex align-items-start">
                <span class="nch--wiki-icon mr-3" :style="{ backgroundColor: color.primary }"><i class="fas fa-book"></i></span>
                <div class="flex-grow-1 min-w-0">
                    <div class="font-weight-bold">{{ w.title }}</div>
                    <div class="text-muted small">
                        {{ relation(w) }}<template v-if="w.classroom"> · {{ $t('wiki.classroom') }} {{ w.classroom }}</template>
                    </div>
                    <div class="mt-2">
                        <span v-if="w.status !== 'not_started'" class="badge badge-pill mr-1" :class="deadlineClass(w)"><i class="far fa-calendar-alt mr-1"></i>{{ deadlineText(w) }}</span>
                        <span class="badge badge-pill" :class="statusClass(w)"><i :class="statusIcon(w)" class="mr-1"></i>{{ status(w) }}</span>
                    </div>
                </div>
                <i class="fas fa-chevron-right text-muted mt-2"></i>
            </div>
        </a>
    </div>
</template>

<script>
import { deadlineLabel, relationLabel, statusLabel } from './wikiHelpers';

/**
 * Minhas wikis (backlog#343): lista das wikis gerais, dos planos e dos cursos
 * do aluno, com vínculo, prazo e situação. Embutida na aba "Wiki da turma" do
 * curso com course-id.
 */
export default {
    name: 'WikiList',

    props: {
        courseId: { type: Number, default: null },
        embedded: { type: Boolean, default: false },
    },

    data: () => ({ wikis: [], loading: true }),

    computed: {
        color() { return this.$store.getters.COLOR || {}; },
    },

    created() {
        window.axios.get('/api/app/wikis', { params: { course_id: this.courseId || undefined } })
            .then(({ data }) => { this.wikis = data || []; })
            .catch(() => { this.wikis = []; })
            .finally(() => { this.loading = false; });
    },

    methods: {
        relation(w) { return relationLabel(w, this.$t.bind(this)); },
        status(w) { return statusLabel(w, this.$t.bind(this)); },
        deadlineText(w) {
            const d = deadlineLabel(w);
            if (!d) return this.$t('wiki.deadline.none');
            return d.key === 'ends_in' ? this.$tc('wiki.deadline.ends_in', d.days, { days: d.days }) : this.$t(`wiki.deadline.${d.key}`, d.params || {});
        },
        deadlineClass(w) {
            const d = deadlineLabel(w);
            if (!d || d.key === 'over' || d.key === 'not_started') return 'badge-light border text-muted';
            return d.days > 3 ? 'badge-light border' : 'badge-warning';
        },
        statusClass(w) { return { editing: 'badge-info', closed: 'badge-light border text-muted', not_started: 'badge-light border text-muted' }[w.status] || 'badge-light'; },
        statusIcon(w) { return { editing: 'fas fa-pen', closed: 'fas fa-lock', not_started: 'far fa-clock' }[w.status] || ''; },
    },
};
</script>

<style scoped>
.nch--wiki-card:hover { box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08) !important; }
.nch--wiki-icon { display: inline-flex; width: 40px; height: 40px; border-radius: 10px; color: #fff; align-items: center; justify-content: center; flex: 0 0 40px; }
.min-w-0 { min-width: 0; }
.nch--wiki-list__embedded { padding-top: 1rem; }
</style>
